import {Routes} from '@angular/router';
import {authGuard} from './guards/auth.guard';
import {MainLayoutComponent} from './layouts/main-layout/main-layout.component';

/**
 * Application routes with improved structure and lazy loading
 * Uses functional guards (Angular 21 best practice)
 */
export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      // Default route - redirects based on user role
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
      },

      // Admin routes
      {
        path: 'admin',
        loadComponent: () => import('./admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'admin/settings/finance',
        loadComponent: () => import('./components/config/finance-settings/finance-settings.component').then(m => m.FinanceSettingsComponent)
      },
      {
        path: 'admin/sap/material',
        loadComponent: () => import('./order/order-sap-material/order-sap-material.component').then(m => m.OrderSapMaterialComponent)
      },
      {
        path: 'admin/sap/orderchanges',
        loadComponent: () => import('./order/order-change-manager/order-change-manager.component').then(m => m.OrderChangeManagerComponent)
      },

      // Dashboard
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
      },

      // Rollout and tab-based views
      {
        path: 'rollout',
        loadComponent: () => import('./components/tab-container/tab-container.component').then(m => m.TabContainerComponent)
      },
      {
        path: 'milestone-tasks',
        loadComponent: () => import('./components/tab-container/tab-container.component').then(m => m.TabContainerComponent)
      },
      {
        path: 'journal-tasks',
        loadComponent: () => import('./components/tab-container/tab-container.component').then(m => m.TabContainerComponent)
      },
      {
        path: 'rollout-reports',
        loadComponent: () => import('./components/tab-container/tab-container.component').then(m => m.TabContainerComponent)
      },
      {
        path: 'epg-reports',
        loadComponent: () => import('./components/tab-container/tab-container.component').then(m => m.TabContainerComponent)
      },
      {
        path: 'usermanagement',
        loadComponent: () => import('./components/tab-container/tab-container.component').then(m => m.TabContainerComponent)
      },
      {
        path: 'target-table',
        loadComponent: () => import('./components/tab-container/tab-container.component').then(m => m.TabContainerComponent)
      },
      {
        path: 'reports-management',
        loadComponent: () => import('./components/tab-container/tab-container.component').then(m => m.TabContainerComponent)
      },
      {
        path: 'upload-sap-file',
        loadComponent: () => import('./components/tab-container/tab-container.component').then(m => m.TabContainerComponent)
      },
      {
        path: 'contract-stack-manager',
        loadComponent: () => import('./components/tab-container/tab-container.component').then(m => m.TabContainerComponent)
      },
      {
        path: 'contract-dashboard',
        loadComponent: () => import('./components/tab-container/tab-container.component').then(m => m.TabContainerComponent)
      },

      // Orders
      {
        path: 'orders',
        loadComponent: () => import('./orders/orders.component').then(m => m.OrdersComponent)
      },
      {
        path: 'orders-in-pool',
        loadComponent: () => import('./orders/orders.component').then(m => m.OrdersComponent)
      },
      {
        path: 'search/:pattern',
        loadComponent: () => import('./orders/orders.component').then(m => m.OrdersComponent)
      },
      {
        path: 'orders/:id',
        loadComponent: () => import('./order/order-detail/order-detail.component').then(m => m.OrderDetailComponent)
      },
      {
        path: 'orders/:id/suborder',
        loadComponent: () => import('./order/sub-order-manager/sub-order-manager.component').then(m => m.SubOrderManagerComponent)
      },
      {
        path: 'orders/:idOrder/material/:idBooking',
        loadComponent: () => import('./order/order-position/order-position.component').then(m => m.OrderPositionComponent)
      },
      {
        path: 'orders/:idOrder/axishoporder/:axishopOrderId',
        loadComponent: () => import('./order/axishop/order-editor/order-editor.component').then(m => m.OrderEditorComponent)
      },
      {
        path: 'orders/:id/sites/:sid',
        loadComponent: () => import('./order/spu-order/order-sites/order-sites.component').then(m => m.OrderSitesComponent)
      },
      {
        path: 'order/finance/:id',
        loadComponent: () => import('./order/order-finance/order-finance.component').then(m => m.OrderFinanceComponent)
      },

      // External orders
      {
        path: 'externalorders',
        loadComponent: () => import('./orders-ext/orders-ext.component').then(m => m.OrdersExtComponent)
      },
      {
        path: 'externalsearch/:pattern',
        loadComponent: () => import('./orders-ext/orders-ext.component').then(m => m.OrdersExtComponent)
      },
      {
        path: 'externalorders/:id',
        loadComponent: () => import('./order/orders-detail-ext/orders-detail-ext.component').then(m => m.OrdersDetailExtComponent)
      },

      // User management
      {
        path: 'profile',
        loadComponent: () => import('./profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: 'register',
        loadComponent: () => import('./user-register/user-register.component').then(m => m.UserRegisterComponent)
      },

      // Help & Support
      {
        path: 'help',
        loadComponent: () => import('./help/help.component').then(m => m.HelpComponent)
      },
      {
        path: 'feedback',
        loadComponent: () => import('./admin/feedback/feedback.component').then(m => m.FeedbackComponent)
      },

      // Suppliers
      {
        path: 'suppliers',
        loadComponent: () => import('./rollout/supplier-management/supplier-management.component').then(m => m.SupplierManagerComponent)
      },
      {
        path: 'suppliers/add',
        loadComponent: () => import('./rollout/supplier-management/create-new-supplier-wizard/create-new-supplier.component').then(m => m.CreateNewSupplierComponent)
      }
    ]
  },

  // Fallback route
  {
    path: '**',
    redirectTo: ''
  }
];
